export interface QrPlaybackSpeedOption {
  readonly label: string;
  readonly durationMs: number;
  readonly experimental: boolean;
}

export const DEFAULT_QR_FRAME_DURATION_MS = 550;

export const QR_PLAYBACK_SPEED_OPTIONS = [
  {
    label: "Most reliable",
    durationMs: 800,
    experimental: false,
  },
  {
    label: "Balanced",
    durationMs: DEFAULT_QR_FRAME_DURATION_MS,
    experimental: false,
  },
  {
    label: "Faster - experimental",
    durationMs: 350,
    experimental: true,
  },
  {
    label: "Very fast - experimental",
    durationMs: 250,
    experimental: true,
  },
  {
    label: "Ultra fast - experimental",
    durationMs: 200,
    experimental: true,
  },
  {
    label: "Fastest - experimental",
    durationMs: 150,
    experimental: true,
  },
] as const satisfies readonly QrPlaybackSpeedOption[];
